module.exports = __webpack_public_path__ + "static/media/mesh basket.16.4d740cc4.png";